import axios from 'axios';
//封装get
export function get(url, params = {}) {
  if (!params.userType) {
    params.userType = 'pub'
  }
  // console.log(params,window.localStorage.getItem("TOKEN"),url+'get请求的参数')
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params,
      headers: {
        'X-Token': window.localStorage.getItem("TOKEN"),
        'X-Domin': window.location.host
      }
    })
      .then(res => {
        // console.log(res,url+'get返回数据')
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
* 封装post请求
*/
const cancelTokens = {}
export function post(url, params, shouldCancelPrevious = true, onCancel = () => { }) {
  if (shouldCancelPrevious && cancelTokens[url]) {
    cancelTokens[url].cancel('Operation canceled by subsequent request to same URL');
    delete cancelTokens[url];
  }
  const cancelTokenSource = axios.CancelToken.source();
  cancelTokens[url] = cancelTokenSource;
  if (!params.memberId) {
    params.memberId = localStorage.getItem('memberId') || null;//pro
  }
  if (!params.userType) {
    params.userType = 'pub'
  }
  return new Promise((resolve, reject) => {
    axios.post(url, params, {
      headers: {
        'X-Token': window.localStorage.getItem("TOKEN"),
        'X-Domin': window.location.host
      },
      cancelToken: cancelTokenSource.token
    })
      .then(res => {
        delete cancelTokens[url];
        resolve(res.data)
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          onCancel(err.message);
        } else {
          reject(err);
        }
      })
  })
}

export function listener(to, from, type) {
  const now = new Date();
  const year = now.getFullYear();
  const month = ('0' + (now.getMonth() + 1)).slice(-2);
  const day = ('0' + now.getDate()).slice(-2);
  const hours = ('0' + now.getHours()).slice(-2);
  const minutes = ('0' + now.getMinutes()).slice(-2);
  const seconds = ('0' + now.getSeconds()).slice(-2);
  const formattedTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  //console.log(to,from,'to')
  var obj = {
    event: type, // 埋点事件名称，例如：点击[1]、跳转[2]、心跳[3]
    publicInfo: {
      shareTime: formattedTime, //	分享时间
      memberId: localStorage.getItem('memberId'), //	用户id
      model: from.title,// 所在模块，个人中心，寄快递，快递列表
    },
    current: {
      path: to.path, //	页面路径
      xdomin: window.location.host,
      title: to.title, //	页面标题
      type: to.listenId, //	当前寄快递1，寄大件2.。。。。
    }
  }

  this.$post('client-count/loading', obj, false).then(res => {
    //console.log(res)
  })
}
  export function getToken() {
    let _this = this;
    localStorage.removeItem('TOKEN')
    localStorage.removeItem('memberId')
    localStorage.setItem("urlState", "urlState");
    let url = location.href;
    this.$post('/client-center/tenantInfo', {}).then((res) => {
      if (res.code == 1) {
        try {
          localStorage.setItem('payPage', res.data.payPage);
          localStorage.setItem('wechatName', res.data.wechatName);
          localStorage.setItem('appId', res.data.publicAppid)
          localStorage.setItem('minOriginAccountId', res.data.minOriginAccountId);
          localStorage.setItem('pubHeadPath', res.data.pubHeadPath)
          localStorage.setItem('skinType', res.data.skinType)
          this.saveShareId()//创建邀约关系
        } catch (e) {
        }
        let componentDomain = res.data.componentDomains + process.env.VUE_APP_LOGIN_URL
        let backUri = 'back_uri=' + encodeURIComponent(url);
        let baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + res.data.publicAppid + '&redirect_uri=' + encodeURIComponent(componentDomain + '?' + backUri) + '&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=' + res.data.componentAppid + '#wechat_redirect';
        window.location.href = baseUrl;
      }
    }).catch((err) => {
    })
  }

  export function initMsgNum() {
    let _this = this;
    _this.$post('/client-message/bubbleData', {}).then(res => {
      const totalScore = Object.values(res.data).reduce((sum, score) => sum + score, 0)
      if (totalScore > 0) {
        _this.$store.state.badgeNum = totalScore
      } else {
        _this.$store.state.badgeNum = 0
      }
    })
  }
  export function getQueryVariableAll(url, variable) {
    var query = url.split("?")[1]; // 根据“?”切割数组，截取“?”之后的字符串
    // ['https://qq.com','appid=1234567890&name=Zdf']
    var vars = query.split("&"); // 根据“&”切割成数组
    // ['appid=1234567890','name=Zdf']
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      // ['appid','1234567890']
      if (pair[0] == variable) return pair[1]; // 没有花括号默认执行第一个js语句
    }
    return (false);
  }
  //axios.defaults.baseURL = 'https://test.pyjkd.com/test'//dat
  //axios.defaults.baseURL = selectBaseUrl()//pro
  axios.defaults.baseURL = process.env.VUE_APP_REQUEST_URL
  axios.default.timeout = 10000;



  let activeRequests = new Map();
  function request(url, data = {}, method = "GET") {
    if (activeRequests.has(url)) {
      activeRequests.get(url).abort();
      activeRequests.delete(url);
    }
    if (!data.memberId) {
      data.memberId = wx.getStorageSync('memberId');
    }
    if (!data.userType) {
      data.userType = 'min';
    }
    let timestamp = new Date().getTime();
    let extConfig = wx.getExtConfigSync ? wx.getExtConfigSync() : {}
    return new Promise(function (resolve, reject) {
      const requestTask = wx.request({
        url: url,
        data: data,
        method: method,
        header: {
          'openid': '',
          'X-Token': wx.getStorageSync('TOKEN'),
          'timestamp': timestamp,
          'X-Domin': extConfig.attr.doMain
        },
        success: function (res) {
          if (res.statusCode == 200) {
            if (res.data.apistatus == 401) {
              wx.removeStorageSync('userInfo');
              wx.removeStorageSync('TOKEN');
              let loginCount = wx.getStorageSync('loginCount') || 0;
              wx.setStorageSync('loginCount', loginCount + 1)
              if (loginCount >= 2) {
                wx.redirectTo({
                  url: '/pages/mailExpress/index',
                });
              } else {
                wx.navigateTo({
                  url: '/pages/mailExpress/index',
                });
              }
            } else if (res.data.apistatus == 402 || res.data.apistatus == 412) {
              showErrorToast(res.data.msg)
              reject(res.data)
            } else if (res.data.apistatus == 99999) {
              wx.reLaunch({
                url: '/pages/maintain/maintain',
              });
            } else {
              resolve(res.data);
            }
          } else {
            reject(res.errMsg);
          }
        },
        fail: function (err) {
          // wx.hideLoading();
          //reject(err)
        },
        complete: function () {
          if (activeRequests.get(url) === requestTask) {
            activeRequests.delete(url);
          }
        }
      })
      activeRequests.set(url, requestTask);
    });
  }